/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './loanfinancialassessment.css';
import parse from 'html-react-parser';

function LoanFinancialAssessment({ data }) {
  // If no data is provided, don't render the component
  if (!data) return null;

  const {
    title,
    subtitle,
    titleColor,
    zigzagColor,
    assessmentItems,
    mainDescription,
    lifeExpectancyFactors,
    fundingTypes
  } = data;

  // Safe parse function to handle undefined or null content
  const safeParse = (content) => {
    if (content === undefined || content === null) return '';
    return parse(content.toString());
  };

  return (
    <div className="financial-assessment-section">
      <Container>
        {/* Title Section */}
        {title && 
          <h2 className="financial-assessment-title" style={{
            color: titleColor,
            textDecorationColor: zigzagColor
          }}>
            {safeParse(title)}
          </h2>
         
        }
         {subtitle && 

         <p className='text-center'> {safeParse(subtitle)}</p>

         }
        {/* Assessment Items */}
        <div className="assessment-items-container">
          {assessmentItems && assessmentItems.map((item, index) => (
            <div key={index} className="assessment-item">
              <span className="assessment-checkmark">✓</span>
              <span className="assessment-text">{safeParse(item.text)}</span>
            </div>
          ))}
        </div>

        {/* Main Description */}
        {mainDescription && 
          <div className="assessment-description">
            <p>{safeParse(mainDescription)}</p>
          </div>
        }

        {/* Life Expectancy Factors */}
        {lifeExpectancyFactors && lifeExpectancyFactors.length > 0 && (
          <div className="life-expectancy-factors">
            {lifeExpectancyFactors.map((factor, index) => (
              <div key={index} className="factor-item">
                <span className="factor-checkmark">✓</span>
                <span className="factor-text">{safeParse(factor.text)}</span>
              </div>
            ))}
          </div>
        )}

        {/* Funding Types */}
        {fundingTypes && fundingTypes.length > 0 && (
          <div className="funding-types-container">
            <Row>
              {fundingTypes.map((type, index) => (
                <Col md={12} key={index} className="funding-type-item">
                  <div className="funding-type-content">
                    <p>{safeParse(type.description)}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </Container>
    </div>
  );
}

export default LoanFinancialAssessment;